var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view-index"},[_c('div',{staticClass:"wrap"},[_vm._v(" お知らせ配信確認 ")])])}]

export { render, staticRenderFns }